import { render, staticRenderFns } from "./BtnInserirDetalheParcelaFixa.vue?vue&type=template&id=255e244d&"
import script from "./BtnInserirDetalheParcelaFixa.vue?vue&type=script&lang=js&"
export * from "./BtnInserirDetalheParcelaFixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports